import { useModal } from "contexts/ModalContext";
import { useTranslations } from "contexts/LocalizationContext";
import FlagBox from "components/LanguageSwitcher/FlagBox";
import { useFlagBoxSettings } from "contexts/SettingsContext";
import { ChakraFlex as Flex, ChakraText as Text } from "@airhelp/react-ui-components";
import { FOOTER_LANG_MODAL_OPEN_GTM, FOOTER_LANG_MODAL_OPEN_MP } from "../../trackingConsts";

const Copyright = () => {
  const translations = useTranslations();
  const { openModal } = useModal();
  const hideFlagBox = useFlagBoxSettings();

  return (
    <Flex justifyContent={hideFlagBox ? "flex-end" : "space-between"} alignItems="center">
      {!hideFlagBox && (
        <FlagBox
          openModal={openModal}
          trackingEvents={{
            gtmEvent: FOOTER_LANG_MODAL_OPEN_GTM,
            mixpanelEvent: FOOTER_LANG_MODAL_OPEN_MP,
          }}
        />
      )}
      <Text color="greyscale.500" fontSize="md">
        {translations("menu_copyright", { "%current-year%": new Date().getFullYear() })}
      </Text>
    </Flex>
  );
};

export default Copyright;
